import React from "react";

import { ReactComponent as CompanyAccountCreationOverview } from "src/assets/icons/process-overview/company-account-creation-overview.svg";
import { ReactComponent as MaintenanceProcessOverview } from "src/assets/icons/process-overview/maintenance-process-overview.svg";
import { ReactComponent as MonitoringAndDashboardsOverview } from "src/assets/icons/process-overview/monitoring-and-dashboards-overview.svg";
import { ReactComponent as PaymentOverview } from "src/assets/icons/process-overview/payment-overview.svg";
import { ReactComponent as RegisterTheFireAndLifeSafetySystemOverview } from "src/assets/icons/process-overview/register-the-fire-and-life-safety-system-overview.svg";
import { ReactComponent as SubscribeBuildingsOverview } from "src/assets/icons/process-overview/subscribe-buildings-overview.svg";
import { ReactComponent as UpdateContractInformationOverview } from "src/assets/icons/process-overview/update-contract-information-overview.svg";

import homeConfig from "src/resources/homePage.json";
import { useTranslation } from "react-i18next";

const ProcessOverview = () => {
  const { t } = useTranslation(["common", "homePage"]);
  const processOverview = homeConfig.processOverview;
  return (
    <section className="home-section benefits process-overview w-100" id="process-overview">
      <div className="d-flex flex-column m-auto w-75">
        <h2 className="title">{t(`homePage.processOverview.title`)}</h2>
        <p className="sub-title">
          {t(`homePage.processOverview.subTitle`)}
        </p>
      </div>
      <div className="benefits-cards">
        {processOverview.items.map((item, index) => (
          <div
            className="item d-flex flex-column align-items-center gap-2 justify-content-center gap-3"
            key={index}
          >
            <span className="card-number">{index + 1}</span>
            {item.icon === "CompanyAccountCreationOverview" && (
              <CompanyAccountCreationOverview />
            )}
            {item.icon === "MaintenanceProcessOverview" && (
              <MaintenanceProcessOverview />
            )}
            {item.icon === "MonitoringAndDashboardsOverview" && (
              <MonitoringAndDashboardsOverview />
            )}
            {item.icon === "PaymentOverview" && <PaymentOverview />}
            {item.icon === "RegisterTheFireAndLifeSafetySystemOverview" && (
              <RegisterTheFireAndLifeSafetySystemOverview />
            )}
            {item.icon === "SubscribeBuildingsOverview" && (
              <SubscribeBuildingsOverview />
            )}
            {item.icon === "UpdateContractInformationOverview" && (
              <UpdateContractInformationOverview />
            )}
            <p>
              {t(`homePage.processOverview.items.item${index + 1}.title`)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessOverview;
